const profileES = {
    header: {
        title: "Perfil del Negocio",
        preview: "Vista previa",
        edit: "Editar",
    },

    reviews: "Reseñas",

    images: {
        addPhoto: "Agregar foto",
        reviews: "reseñas",
        noPhotos: "Aún no hay fotos",
        title: "Imágenes",
        makeCover: "Establecer como portada",
        replace: "Reemplazar",
        delete: "Eliminar",
        cover: "Portada",
        noImageSelected: "No hay imagen seleccionada",
        confirmDelete: "¿Estás seguro de que quieres eliminar esta imagen?",
    },

    services: {
        title: "Servicios",
        add: "+ Agregar Servicios",
        empty: "No hay servicios aún.",
        emptyCategory: "No hay servicios en esta categoría",
        name: "Nombre del servicio",
        price: "Precio",
        hours: "Horas",
        minutes: "Minutos",
        description: "Descripción",
        category: "Categoría",

        placeholderName: "Nombre del servicio",
        placeholderDescription: "Descripción del servicio",

        homeService: "A domicilio",
        inShop: "En el local",
        transitTimeLabel: "Tiempo de traslado antes del servicio (minutos)",
    },

    actions: {
        saveChanges: "Guardar cambios",
        cancel: "Cancelar",
    },

    errors: {
        fillAllFields: "Por favor, completa todos los campos obligatorios.",
    },

    /* ───────────── Sidebar ───────────── */
    sidebar: {
        location: {
            title: "Ubicación",
        },
        contact: {
            title: "Contacto",
            phone: "Teléfono",
            email: "Correo electrónico",
            noPhone: "Teléfono no disponible",
            noEmail: "Correo no disponible",
            socialTitle: "Redes sociales",
            website: "Sitio web",
            instagram: "Instagram",
            facebook: "Facebook",
            tiktok: "TikTok",
        },
        hours: {
            title: "Horario de apertura",
            show: "Mostrar más horarios",
            hide: "Ocultar horarios",
            closed: "Cerrado",
            edit: "Editar horario",
        },
        staff: {
            title: "Equipo",
            edit: "Gestionar equipo",
            roles: {
                admin: "Administrador",
                staff: "Empleado",
                owner: "Propietario",
            },
            noStaff: "No hay miembros en el equipo.",
            addStaff: "Invitar miembro",
            remove: "Eliminar",
            editRole: "Cambiar rol",
        },
    },

    /* ───────────── Modales ───────────── */
    modal: {
        shopInfo: {
            title: "Información del negocio",
            subTitle: "Detalles",
            name: "Nombre del negocio",
            description: "Descripción",
            address: "Dirección",
            city: "Ciudad",
            country: "País",
        },
        contact: {
            title: "Información de contacto",
            description: "Actualiza el teléfono, correo y redes sociales.",
        },
        hours: {
            title: "Horario comercial",
            description: "Configura los horarios de apertura y cierre por día.",
            open: "Abre",
            close: "Cierra",
            closed: "Cerrado",
        },
        team: {
            title: "Miembros del equipo",
            description: "Administra los miembros del equipo y sus roles.",
            addButton: "Invitar miembro",
            close: "Cerrar",
            save: "Guardar",
        },
    },

    categories: {
        cannotDeleteWithServices: "Debes eliminar o mover todos los servicios antes de borrar esta categoría",
        addCategory: "Añadir categoría",
        newCategory: "Nueva categoría",
    },

    addAddress: "Agregar dirección",
    addServices: "+ Agregar o editar tus servicios",
    footerEmpty: "No hay servicios en esta categoría",
    addFirstServices: "+ Agrega tu primer servicio",
    addShopName: "Agregar nombre del local",
    noReviewsyet: "Todavía no hay reseñas",
    addAttributes: "+ Agregar tus atributos",
    addDescription: "Agrega una breve descripción sobre tu negocio",

    errors: {
        fillAllFields: "Por favor, completa todos los campos obligatorios.",
    },
};

export default profileES;
